/**
 * Shared stop-loss helpers used by TradingDashboard and RiskDashboard.
 *
 * Futures: lot-based schedule (1→₹1000, 2→₹1500, … 10→₹7000, +₹700/lot
 * beyond 10). Equity/options: 2% of deployed capital.
 */

export const FUTURES_LOT_SL_SCHEDULE: Record<number, number> = {
  1: 1000, 2: 1500, 3: 2000, 4: 3000, 5: 3500,
  6: 4500, 7: 5000, 8: 5500, 9: 6000, 10: 7000,
};

export function getFuturesSLAmount(lots: number): number {
  if (lots <= 0) return 0;
  if (lots <= 10) return FUTURES_LOT_SL_SCHEDULE[lots] || 7000;
  return 7000 + (lots - 10) * 700;
}
